<div [ngClass]="{'success-msg': statusFlag, 'error-msg': !statusFlag && !profitFlag} ">
    <div class="custom-modal modal-container" id="wrapper">
        <div class="modal-body">
            <div class="container" [ngClass]="{'p-0' : profitFlag }">
                <div class="text-center" [ngClass]="{'tick-icon': statusFlag, 'mtop15': topCutOff, 'error-icon': !statusFlag}"></div>
                <div class="conf-txt text-center success-content" [innerHTML]="successMessage"></div>
            </div>
        </div>
        <div class="modal-footer" *ngIf="profitFlag">
            <div class="confirm-actions">
                <button class="btn action-btn submit" (click)="activeModal.dismiss('Cross click')">OK<span class="submit-btn"></span></button>
            </div>
    </div>
</div>